module.exports = __webpack_public_path__ + "static/media/Panel_R.1cd4af88.png";